<style scoped>
.abs-col {
  overflow-y: scroll;
  padding: 0;
  background-color: white;
  height: 100vh;
}

.abs-col:last-child {
  z-index: 1;
  box-shadow: 2px 3px 6px 0px black;
}

ul.collapsible {
  margin: 0;
  border: 0;
}

.collapsible-body {
  padding: 0;
}

.collapsible-body li {
  display: block;
  padding: 18px 24px;
}

.collapsible-body li:not(:last-child) {
  border-bottom: 1px solid lightgray;
}
.sms-cont {
  margin: 10% 10%;
}
.lstcontact {
  display: flow-root;
}
.lstcontact > li {
  /* padding:5px;
    background: lightgray;
    border-radius: 10px;
    margin:2px 5px; */
  float: left;
  width: auto;
}
.contact-box {
  padding: 0 10px;
  color: black !important;
}
.txtblack {
  color: black !important;
}
.removebtn {
  border-radius: 10px;
  border: none;
  background: #f34e4e;
  color: white;
}
.btnsend {
  margin-right: 20px;
}

.maxchar-label {
  display: block;
  margin-bottom: 12px;
}
li .collapsible-header:after {
 font-family: 'Material Icons';
  content: "expand_less";
  font-size: 18px;
}
li.active .collapsible-header:after {
  content: 'expand_more';
}
</style>

<template lang="pug">
    .main-content-nopad
      .row
        .abs-col.col.l3.m4.s12
          ul.collapsible(ref='collapsibleUsers')
            li
                .collapsible-header.active(v-if='bcrumSms && bcrumSms.new') Staff
                  span.badge {{filterBySupplier.length}}
                .collapsible-header.active(v-else) Staff
                  span.badge {{filterBySupplier.length}}
                .collapsible-body
                  ul
                    li
                      input(type="text" v-model="searchSupplier" placeholder="Search Username" )
                    li
                      label(@click='newSms')
                        input(type='checkbox' class='filled-in' @change='selectAllSupplier($event.target.checked)' )
                        span.txtblack &nbsp; Select All ({{filterBySupplier.length}})
                  ul(v-if='filterBySupplier.length > 0')
                    li.waves-effect(v-for='lstSupplier in filterSearchSupplier')
                      label(@click='newSms')
                        input(type='checkbox' class='filled-in' v-model="selectedUsers"  :value='lstSupplier' v-if='lstSupplier.account.phoneNumber')
                        span.txtblack &nbsp; {{lstSupplier.account.firstName}} {{lstSupplier.account.lastName}}
                        span.badge(v-if='lstSupplier.account.phoneNumber') +63{{lstSupplier.account.phoneNumber}}
                        span.badge(v-else)  Not Available
                  div.center-align(v-else)
                    .vspace.small
                    p.grey-text No items available
                    .vspace.small
            li
              .collapsible-header.active(v-if='bcrumSms && bcrumSms.new') Resellers
                span.badge {{filterByReseller.length}}
              .collapsible-header.active(v-else) Resellers
                span.badge {{filterByReseller.length}}
              .collapsible-body
                ul
                  li
                    input(type="text" v-model="searchUsers" placeholder="Search Username")
                  li
                    label(@click='newSms')
                      input(type='checkbox' class='filled-in' @change='selectAllReseller($event.target.checked)' )
                      span.txtblack &nbsp; Select All ({{filterByReseller.length}})
                ul(v-if='filterByReseller.length > 0')
                  li.waves-effect(v-for='userlst in filterSearchReseller')
                   label(@click='newSms')
                    input(type='checkbox' class='filled-in' v-model="selectedUsers"  :value='userlst' v-if='userlst.account.phoneNumber')
                    span.txtblack &nbsp; {{userlst.account.firstName}} {{userlst.account.lastName}}
                    span.badge(v-if='userlst.account.phoneNumber') +63{{userlst.account.phoneNumber}}
                    span.badge(v-else) Not Available
                div.center-align(v-else)
                  .vspace.small
                  p.grey-text No items available
                  .vspace.small
            li
              .collapsible-header.active(v-if='bcrumSms && bcrumSms.new') Shopper
                span.badge {{filterByCustomer.length}}
              .collapsible-header.active(v-else) Shopper
                span.badge {{filterByCustomer.length}}
              .collapsible-body
                ul
                  li
                    input(type="text" v-model="searchCustomer" placeholder="Search Username")
                  li
                    label(@click='newSms')
                      input(type='checkbox' class='filled-in' @change='selectAllCustomer($event.target.checked)' )
                      span.txtblack &nbsp; Select All ({{filterByCustomer.length}})
                ul(v-if='filterByCustomer.length > 0')
                  li.waves-effect(v-for='userlstcustonmer in filterSearchCustomer')
                    label(@click='newSms')
                      input(type='checkbox' class='filled-in' v-model="selectedUsers"  :value='userlstcustonmer' v-if='userlstcustonmer.account.phoneNumber')
                      span.txtblack &nbsp; {{userlstcustonmer.account.firstName}} {{userlstcustonmer.account.lastName}}
                      span.badge(v-if='userlstcustonmer.account.phoneNumber') +63{{userlstcustonmer.account.phoneNumber}}
                      span.badge(v-else)  Not Available
                div.center-align(v-else)
                  .vspace.small
                  p.grey-text No items available
                  .vspace.small


        .col.l9.m8
          .col.s12
            .bcrumb
              a(href='#', @click='resetMessages') Messages
              a(v-if='bcrumSms && bcrumSms.new') New
              a(v-if='bcrumSms && !bcrumSms.new')
          div.sms-cont.card()
            div.card-content
              h5 New Message
              div
                label To:
                  ul.lstcontact(v-if="showLess")
                    li.chip(v-for='selectuser, index in selectedUsers.slice(0, 10)')
                      label.contact-box {{selectuser.account.firstName}} {{selectuser.account.lastName}}
                      button.removebtn(@click="remove(index)") &times
                    li.chip(@click="showLess = !showLess", v-if="selectedUsers.length > 10" )
                      label.contact-box {{showLess===true? "Show All" : "Show Less"}}
                  ul.lstcontact(v-else)
                    li.chip(v-for='selectuser, index in selectedUsers')
                      label.contact-box {{selectuser.account.firstName}} {{selectuser.account.lastName}}
                      button.removebtn(@click="remove(index)") &times
                    li.chip(@click="showLess = !showLess", v-if="selectedUsers.length > 10" )
                      label.contact-box {{showLess===true? "Show All" : "Show Less"}}
                  //- button.btn(@click="showLess = !showLess", v-if="selectedUsers.length > 10" ) {{showLess===true? "Show All" : "Show Less"}}
              .divider
              br
              br
              div
                label Message :
                textarea.materialize-textarea#txtmsg(v-model= "contstr.message" maxlength="160" )
                label.maxchar-label 160 maximum character
                button.btn.waves-effect.waves-light.btnsend(@click='sendMessage', :disabled='selectedUsers.length <= 0 || !contstr.message' ) Send
                  i.material-icons.right send
                button.btn.red(@click='cancelMessage', :disabled='selectedUsers.length <= 0 || !contstr.message')  Cancel
          a.btn-floating.btn-large.waves-effect.waves-light.indigo.bottom-right(@click='newSms')
            i.material-icons add



</template>
<script>
/* eslint-disable no-undef */
import AppSmsDetails from "@/components/app-sms-details";
import axios from "axios";
import VueModal from "vue-modal";

export default {
  meta: {
    title: "SMS"
  },
  data() {
    return {
      showLess: true,
      deliveryJobs: [],
      searchUsers: "",
      searchSupplier: "",
      searchCustomer: "",
      contstr: { to: null, message: null },
      contactList: [],
      selectedUsers: [],
      selectedJob: null,
      modalContent: AppSmsDetails,
      jobRefreshInterval: null,
      bcrumSms: null,
      smsData: [
        {
          contactName: "Lorem Ipsum",
          Contact: "9358624066",
          smsBody:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry`s standard dummy text ever since the 1500s",
          dateSent: "Jan 14, 2018"
        },
        {
          contactName: "Lorem Ipsum",
          Contact: "9358624066",
          smsBody:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry`s standard dummy text ever since the 1500s",
          dateSent: "Jan 14, 2018"
        },
        {
          contactName: "Lorem Ipsum",
          Contact: "9358624066",
          smsBody:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry`s standard dummy text ever since the 1500s",
          dateSent: "Jan 14, 2018"
        }
      ],
      contTypeReseller: "reseller",
      contTypeSupplier: "supplier",
      contTypeCustomer: "customer",
      contTypeAdmin: "admin"
    };
  },
  created() {
    this.getDeliveryJobs();
    if (this.$route.params.referenceNumber) {
      this.getSelectedJobByReferenceNumber();
    }
  },
  mounted() {
    this.$M.Collapsible.init(this.$refs.collapsibleUsers);
    this.jobRefreshInterval = setInterval(this.getDeliveryJobs, 60000);
    this.getContactList();
  },
  destroyed() {
    clearInterval(this.jobRefreshInterval);
  },
  computed: {
    contactToString() {
      return this.selectedUsers.map(item => "63" + item.account.phoneNumber);
    },
    contactlsttosend() {
      // this.contactToString.join()
      return this.contactToString.toString();
      // return JSON.stringify(this.contactToString)
    },
    pushContact() {
      this.contstr.to = this.contactlsttosend;
    },
    sortedOrders() {
      return this.orders.sort(this.orderSortFunction);
    },
    sortedOrderItems() {
      return this.orderItems.sort(this.orderItemSortFunction);
    },
    filterSearchReseller() {
      return this.filterByReseller.filter(user => {
        return (
          !this.searchUsers ||
          user.account.firstName
            .toLowerCase()
            .indexOf(this.searchUsers.toLowerCase()) > -1
        );
      });
    },
    filterByReseller() {
      return this.contactList.filter(user => {
        if (user.account.phoneNumber) {
          return (
            !this.contTypeReseller ||
            user.account.type
              .toLowerCase()
              .indexOf(this.contTypeReseller.toLowerCase()) > -1
          );
        }
      });
    },
    filterSearchSupplier() {
      return this.filterBySupplier.filter(userSupplier => {
        return (
          !this.searchSupplier ||
          userSupplier.account.firstName
            .toLowerCase()
            .indexOf(this.searchSupplier.toLowerCase()) > -1
        );
      });
    },
    filterBySupplier() {
      return this.contactList.filter(user => {
        if (user.account.phoneNumber) {
          return (
            !this.contTypeSupplier ||
            user.account.type
              .toLowerCase()
              .indexOf(this.contTypeSupplier.toLowerCase()) > -1
          );
        }
      });
    },
    filterSearchCustomer() {
      return this.filterByCustomer.filter(userCustomer => {
        return (
          !this.searchCustomer ||
          userCustomer.account.firstName
            .toLowerCase()
            .indexOf(this.searchCustomer.toLowerCase()) > -1
        );
      });
    },
    filterByCustomer() {
      return this.contactList.filter(user => {
        if (user.account.phoneNumber) {
          return (
            !this.contTypeCustomer ||
            user.account.type
              .toLowerCase()
              .indexOf(this.contTypeCustomer.toLowerCase()) > -1
          );
        }
      });
    }
  },
  watch: {
    "$route.params"() {
      this.getSelectedJobByReferenceNumber();
    }
  },
  methods: {
    newSms() {
      this.bcrumSms = {
        new: true
      };
    },
    selectedsuppliers() {
      this.selectedUsers = this.filterBySupplier;
    },
    resetMessages() {
      this.bcrumSms = null;
      this.selectedUsers = [];
    },
    remove(index) {
      this.$delete(this.selectedUsers, index);
    },
    selectAll(selectAll) {
      if (selectAll) {
        this.selectedUsers = this.contactList;
      } else {
        this.selectedUsers = [];
      }
    },
    selectAllSupplier(selectAll) {
      if (selectAll) {
        this.selectedUsers = this.filterBySupplier;
      } else {
        this.selectedUsers = [];
      }
    },
    selectAllReseller(selectAll) {
      if (selectAll) {
        this.selectedUsers = this.filterByReseller;
      } else {
        this.selectedUsers = [];
      }
    },
    selectAllCustomer(selectAll) {
      if (selectAll) {
        this.selectedUsers = this.filterByCustomer;
      } else {
        this.selectedUsers = [];
      }
    },
    orderSortFunction(orderA, orderB) {
      const fieldA = orderA["referenceNumber"];
      const fieldB = orderB["referenceNumber"];

      let result = 0;
      result =
        fieldA.toLowerCase() < fieldB.toLowerCase()
          ? -1
          : fieldA.toLowerCase() === fieldB.toLowerCase()
          ? 0
          : 1;

      return this.toggleSort ? result * -1 : result;
    },
    orderItemSortFunction(orderItemA, orderItemB) {
      const fieldA = orderItemA["status"];
      const fieldB = orderItemB["status"];

      let result = 0;
      result =
        fieldA.toLowerCase() < fieldB.toLowerCase()
          ? -1
          : fieldA.toLowerCase() === fieldB.toLowerCase()
          ? 0
          : 1;

      return this.toggleSort ? result * -1 : result;
    },
    onOrderUpdated(order) {
      this.getSelectedJobByReferenceNumber(order.referenceNumber);
      this.getDeliveryJobs();
    },
    cancelMessage() {
      this.contstr = { to: null, message: null };
      this.selectedUsers = [];
    },
    sendMessage() {
      this.contstr.to = this.contactlsttosend;
      this.$store.dispatch("auth/getAccessToken").then(accessToken => {
        axios
          .post(`${this.$config.API_URL}/admin/send-message`, this.contstr, {
            headers: {
              Authorization: `Bearer ${accessToken}`
            }
          })
          .then(result => {
            this.contstr = { to: null, message: null };
            this.$snackbar.show({ text: "Message Successfully sent!" });
          });
      });
    },
    getDeliveryJobs() {
      this.$store.dispatch("auth/getAccessToken").then(accessToken => {
        axios
          .get(
            `${this.$config.API_URL}/admin/delivery-jobs?deliveredBy=inomph`,
            {
              headers: {
                Authorization: `Bearer ${accessToken}`
              }
            }
          )
          .then(result => {
            this.deliveryJobs = result.data;
            this.$store.commit(
              "config/setDeliveryJobsCount",
              result.data.length
            );
          });
      });
    },
    getContactList() {
      this.$store.dispatch("auth/getAccessToken").then(accessToken => {
        axios
          .get(`${this.$config.API_URL}/admin/user-list`, {
            headers: {
              Authorization: `Bearer ${accessToken}`
            }
            // ,
            // params: this.$route.query
          })
          .then(result => {
            this.contactList = result.data;
          });
      });
    },
    getSelectedJobByReferenceNumber() {
      if (!this.$route.params.referenceNumber) {
        this.selectedJob = null;
        return;
      }

      this.$store.dispatch("auth/getAccessToken").then(accessToken => {
        return axios
          .get(
            `${this.$config.API_URL}/admin/delivery-jobs/${
              this.$route.params.referenceNumber
            }`,
            {
              headers: {
                Authorization: "Bearer " + accessToken
              }
            }
          )
          .then(result => {
            this.selectedJob = result.data;
          });
      });
    },
    showOrderDetails(index) {
      this.order = this.orders[index];
      this.orderIndex = index;

      axios
        .get(
          `${this.$config.API_URL}/admin/orders?referenceNumber=` +
            this.order.referenceNumber +
            `&deep=true&deliveredBy=Inomph&status=In-Transit`
        )
        .then(result => {
          this.orderItems = result.data[0].orderItems;
        });
    },
    viewJob(job) {
      this.$router.push({
        name: "deliveryJobsByReference",
        params: { referenceNumber: job.deliveryJobReferenceNumber }
      });
    },
    modalClose() {
      this.selectedJob = null;
      this.$router.back();
    }
  },
  components: {
    AppSmsDetails,
    VueModal
  }
};
</script>



// WEBPACK FOOTER //
// src/components/page-sms.vue